var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 12.5a9 9 0 019-9v0a9 9 0 019 9v0a9 9 0 01-9 9v0a9 9 0 01-9-9v0z",
    stroke: "#7D8085",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.563 14.188L12.5 10.25l3.938 3.938",
    stroke: "#7D8085",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMy41IDEyLjVDMy41IDcuNTI5NDQgNy41Mjk0NCAzLjUgMTIuNSAzLjVWMy41QzE3LjQ3MDYgMy41IDIxLjUgNy41Mjk0NCAyMS41IDEyLjVWMTIuNUMyMS41IDE3LjQ3MDYgMTcuNDcwNiAyMS41IDEyLjUgMjEuNVYyMS41QzcuNTI5NDQgMjEuNSAzLjUgMTcuNDcwNiAzLjUgMTIuNVYxMi41WiIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuNSIvPgogIDxwYXRoIGQ9Ik04LjU2MjUgMTQuMTg3NUwxMi41IDEwLjI1TDE2LjQzNzUgMTQuMTg3NSIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgCollapse as ReactComponent };